/* Section definitions and id→route mapping for the AppShell nav.
   Ported from lib/shell.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import type { IconName } from '../Icon';

export interface Section {
  id: string;
  label: string;
  icon: IconName;
  path: string;
}

export const SECTIONS: Section[] = [
  { id: 'overview', label: 'Overview', icon: 'activity', path: '/overview' },
  { id: 'profile', label: 'User Profile', icon: 'user', path: '/user-profile' },
  {
    id: 'interviews',
    label: 'Interviews',
    icon: 'list-tree',
    path: '/interviews',
  },
  {
    id: 'options',
    label: 'Options',
    icon: 'sliders-horizontal',
    path: '/options',
  },
  {
    id: 'rules',
    label: 'Match Rules',
    icon: 'git-branch',
    path: '/match-rules',
  },
  {
    id: 'match-test',
    label: 'Match Test',
    icon: 'target',
    path: '/match-test',
  },
  {
    id: 'matchmaker-chat',
    label: 'Matchmaker Chat',
    icon: 'wand-sparkles',
    path: '/matchmaker-chat',
  },
  {
    id: 'conversations',
    label: 'Conversation History',
    icon: 'messages-square',
    path: '/conversation-history',
  },
  { id: 'events', label: 'Events', icon: 'calendar', path: '/events' },
  {
    id: 'vector-labels',
    label: 'Vector Labels',
    icon: 'hash',
    path: '/vector-labels',
  },
  {
    id: 'win-back',
    label: 'Win-back',
    icon: 'heart',
    path: '/win-back',
  },
  {
    id: 'app-versions',
    label: 'App Versions',
    icon: 'phone',
    path: '/app-versions',
  },
];

/** Return the Section whose path matches the current pathname prefix, or undefined. */
export function getSectionByPath(pathname: string): Section | undefined {
  // Sort by path length descending so more specific paths match first
  return [...SECTIONS]
    .sort((a, b) => b.path.length - a.path.length)
    .find((s) => pathname === s.path || pathname.startsWith(s.path + '/'));
}
